<template>
  <div>
      <v-card>
        <v-card-title>
          <h1>Audit Logs</h1>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-container container--fluid grid-list-md>
           <v-row justify="space-around" align="center" v-if="$vuetify.breakpoint.mdAndUp">
            <v-col cols="4" class="text-center">
              <v-avatar color="blue darken-1">
                <span class="white--text headline">1</span>
              </v-avatar>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-avatar color="#083a95">
                <span class="white--text headline">2</span>
              </v-avatar>
            </v-col>
           </v-row>
           <v-row align="center" :class="{'justify-center': $vuetify.breakpoint.smAndDown}" :justify-space-around="typeOfLog">
            <v-col cols="10" md="4">
              <v-select
                v-model="typeOfLog"
                :items="typesOfLogs"
                label="Choose Type Of Log..."
                item-text="text"
                return-object></v-select>
            </v-col>
            <v-col cols="12" md="4" class="text-center" v-if="typeOfLog">
              <v-icon>{{$vuetify.breakpoint.smAndDown ? 'fas fa-arrow-down':'fas fa-arrow-right'}}</v-icon>
            </v-col>
            <v-col cols="10" md="4" v-if="typeOfLog">
              <v-text-field
                v-model="code"
                :label="typeOfLog.code_label"
                :prepend-inner-icon="typeOfLog.icon"
              ></v-text-field>
            </v-col>
           </v-row>

           <v-row justify="center" v-if="typeOfLog">
            <v-col cols="12" md="2" class="text-center">
              <v-btn text block color="blue darken-1" @click="getLogs">Search</v-btn>
            </v-col>
           </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-data-table
          :items="renderedLogs"
          :headers="filteredHeaders"
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr>
              <template v-for="(field, index) in filteredHeaders">
                <td :key="index" style="text-align: center">
                  <template v-if="field.text !== 'Actions'">
                    {{ props.item[field.value] }}
                  </template>
                  <template v-else>
                    <v-tooltip top color="secondary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                          delete
                        </v-icon>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </template>
                </td>
              </template>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog
        v-model="deleteDialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title class="justify-center">
            <h3>ATTENTION</h3>
          </v-card-title>
          <v-card-text class="text-center">
            You are about to delete this data on redis. This action cannot be undone. <br>
            Are you sure you want to proceed?
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
            <v-btn text @click="toggleDelete" color="blue darken-1">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    name: "LogsDisplayer",
    data() {
      return {
        logs: null,
        typeOfLog: null,
        code: null,
        deleteDialog:false,
        toBeDeleted:null,
        loading: false,
        reload: false,
        typesOfLogs: [
          {text: 'Delivery', value: 'Delivery', code_label: 'Tracking ID', icon: 'search'},
          {text: 'Client', value: 'Client', code_label: 'Client ID', icon: 'people_outline'},
          {text: 'Time Window', value: 'TimeWindow', code_label: 'Time Window ID ', icon: 'access_time'},
          {text: 'Manifest', value: 'Manifest', code_label: 'Manifest ID', icon: 'insert_drive_file'},
          {text: 'Contractor', value: 'Contractor', code_label: 'Contractor ID', icon: 'search'},
          {text: 'Driver', value: 'Driver', code_label: 'Driver ID', icon: 'search'},
          {text: 'Search', value: 'Search', code_label: 'Key', icon: 'search'}
        ],
        headers: [
          {text: 'Last time call', value: 'time', align: 'center', sortable: false},
          {text: 'Client Name', value: 'client_name', align: 'center', sortable: false},
          {text: 'Username', value: 'username', align: 'center', sortable: false},
          {text: 'IP Address', value: 'ip', align: 'center', sortable: false},
          {text: 'Message', value: 'message', align: 'center', sortable: false},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ]
      }
    },
    methods: {
      getLogs() {
        if (this.code !== null) {
          if(this.typeOfLog.value === 'Search'){
            axios.get(process.env.API_URL + '/auditlogs/query/'+ this.code)
              .then((response) => {
                this.logs = response.data;
              })
              .catch((response) => {
                this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
              })

          } else {
            axios.get(process.env.API_URL + '/auditlogs/audit/' + this.typeOfLog.value + '/' + this.code)
              .then((response) => {
                this.logs = response.data;
                console.log(Object.keys(this.logs));
              })
              .catch((response) => {
                this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
              });
          }
        } else {
            this.$store.commit('displaySnackbar', 'Please fill the ' + this.typeOfLog.code_label + 'field.');
        }
      },
      deleteRow() {
        this.toBeDeleted = this.code;
        this.deleteDialog = true;
      },
      toggleDelete(){
        this.PerformDelete();
        this.deleteDialog = false;
      },
      PerformDelete() {
        axios.delete(process.env.API_URL + '/auditlogs/query/' + this.toBeDeleted)
          .then((response) => {
            this.toBeDeleted = null;
            this.getLogs();
            this.$store.commit('displaySnackbar', 'Delete successful');
          })
          .catch((error) => {
            this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
          });
      },
    },
    computed: {
      renderedLogs() {
        let output = [];
        let logs = null;
        if (this.logs !== null) {
          if(this.typeOfLog.value === 'Search'){
            const currentTime = new Date().toLocaleString();
            if(this.logs.type === undefined){
              logs = this.logs;
            }
            return [{
              time: currentTime,
              client_name: this.$store.getters['auth/username'],
              username: 'admin',
              ip: '192.168.1.1',
              message:logs,

            }]
          } else {
            for (var object of Object.keys(this.logs)) {
              output.push({});
              for (var key of Object.keys(this.logs[object])) {
                if (key !== 'user') {
                  output[object][key] = this.logs[object][key];
                } else {
                  // Take all fields of user
                  for (var user_key of Object.keys(this.logs[object][key])) {
                    output[object][user_key] = this.logs[object][key][user_key];

                  }
                }
              }
            }
          }
        }
        return output
      },
      filteredHeaders() {
        if (this.typeOfLog != null && this.typeOfLog.value === 'Search') {
          return this.headers;
        } else {
          return this.headers.filter(header => header.text !== 'Actions');
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/LogsDisplayer.vue